const FLAGS_BY_ENV = {
  local: {
    EMAILS: true,
    MY_EMAILS: true,
    SEND_EMAILS: true
  },
  dev: {
    EMAILS: true,
    MY_EMAILS: true,
    SEND_EMAILS: true
  },
  uat: {
    EMAILS: true,
    MY_EMAILS: true,
    SEND_EMAILS: true
  },
  prod: {
    EMAILS: true,
    MY_EMAILS: true,
    SEND_EMAILS: true
  }
} as const;

const env = import.meta.env.VITE_ENV as keyof typeof FLAGS_BY_ENV | undefined;
export const FeatureFlags = Object.freeze((env && FLAGS_BY_ENV[env]) ?? FLAGS_BY_ENV.dev);
